var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticStyle:{"max-height":"966px"},attrs:{"id":"xgplayer"}}),_c('span',{staticClass:"count",staticStyle:{"visibility":"hidden"}},[_vm._v(_vm._s(_vm.count)+"s")])])
}
var staticRenderFns = []

export { render, staticRenderFns }